import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const flushService = {

    flushCategory,
    flushPlan,
    flushSearchInf,
    flushUserData
};


function flushCategory() {
    return fetchWrapper.post(
        `${baseUrl}/admin/tama-categories/flush-cache`, {}
    );
}
function flushPlan() {
    return fetchWrapper.post(
        `${baseUrl}/admin/plans/flush-cache`, {}
    );
}
function flushSearchInf() {
    return fetchWrapper.post(
        `${baseUrl}/admin/infs/flush-cache`, {}
    );
}

function flushUserData() {
    return fetchWrapper.post(
        `${baseUrl}/admin/user-data/flush-cache`, {}
    );
}









